<template>
  <v-content id="notification-setting-content">
    <v-list subheader three-line>
      <template v-for="(livers, grad) in typedLivers">
        <v-subheader class="headline notification-setting-subheader-view">{{grad}}</v-subheader>
        <v-list-item v-for="liver in livers" @click="">
          <v-list-item-content>
            <v-list-item-title class="title">{{liver.name}}</v-list-item-title>
            <v-list-item-subtitle class="subheading">
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch></v-switch>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-content>
</template>

<style scoped>
  #notification-setting-content {
    padding-top: 0px !important;
    padding-left: 0px !important;
  }

  .notification-setting-subheader-view {
    background-color: #6CBFEB;
    color: #FFFFFF !important;
    font-weight: bold !important;
  }

  .img-btn {
    min-width: auto !important;
    height: auto !important;
    padding: 0px !important;
  }
</style>

<script>
import api from '@/util/api.js';
import { logo, grad } from '@/util/config.js'

  export default {
    data: () => ({
      livers: [],
      selectedSite: null
    }),

    props: {
    },

    computed: {
      typedLivers: function() {
        return this.livers.reduce((acc, liver) => {
          if(!acc[grad[liver.graduation]]) {
            acc[grad[liver.graduation]] = [];
          }
          acc[grad[liver.graduation]].push(liver);
          return acc;
        }, {});
      }
    },

    created() {
      console.log('Liver Component created.')
      this.initialize(this);
    },

    mounted() {
      console.log('Liver Component mounted.')
    },

    methods: {
      initialize: (self) => api.get("/livers").then(res => {
        console.log(res.data);
        self.livers = res.data;
      }).catch(e => console.log(e)),
    },

  }
</script>
